<h1 mat-dialog-title>Passagier {{ data.type === 'hide' ? 'verstoppen' : 'laten zien' }}?</h1>
<div mat-dialog-content>
  @if (data.type == 'hide') {
    <div class="hide-user">
      <p>Weet je zeker dat je {{ data.user.name }} wilt verstoppen?</p>
      @if (data.user.cardId) {
        <p class="notification">
          Let op: de passagier heeft nog een gekoppeld kaartnummer. Deze blijft gekoppeld als je de passagier verstopt
          zonder het kaartnummer los te koppelen.
        </p>
      }
    </div>
  }
  @if (data.type == 'show') {
    <p>Wil je {{ data.user.name }} weer laten zien?</p>
  }
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">Nee</button>
  <button mat-flat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Ja</button>
</div>
